import { Link, useLocation } from "react-router-dom";
import { ReactComponent as LeaderboardIcon } from "../assets/images/Leaderboard.svg";
import { ReactComponent as RewardIcon } from "../assets/images/Rewards.svg";
import { ReactComponent as LeaderboardIconLight } from "../assets/images/LeaderboardLight.svg";
import { ReactComponent as RewardIconLight } from "../assets/images/RewardsLight.svg";

const Footer = () => {
  const location = useLocation();
  const currentPath = location.pathname;

  const menuItems = [
    {
      name: "Home",
      path: "/home",
      icon: <i className="fa-solid fa-house fa-lg"></i>,
    },
    // {
    //   name: "Schedule",
    //   path: "/schedule",
    //   icon: <i className="fa-solid fa-calendar-day fa-lg"></i>,
    // },
    {
      name: "Clock",
      path: "/clock",
      icon: <i className="fa-solid fa-clock fa-lg"></i>,
    },
    {
      name: "Leaderboard",
      path: "/leaderboard",
      icon: (isActive) =>
        isActive ? (
          <LeaderboardIcon className="text-footer-active" />
        ) : (
          <LeaderboardIconLight />
        ),
    },
    {
      name: "Rewards",
      path: "/rewards",
      icon: (isActive) =>
        isActive ? (
          <RewardIcon className="text-footer-active" />
        ) : (
          <RewardIconLight />
        ),
    },
  ];

  const isPathActive = (itemPath) => {
    if (Array.isArray(itemPath)) {
      return itemPath.includes(currentPath);
    }
    return currentPath === itemPath;
  };

  return (
    <footer className="fixed-bottom footer-part">
      <div className="d-flex justify-content-between">
        {menuItems.map((item) => {
          const isActive = isPathActive(item.path);

          return (
            <Link
              key={item.name}
              to={Array.isArray(item.path) ? item.path[0] : item.path}
              className={`d-flex flex-column align-items-center footer-item ${
                isActive ? "active" : ""
              }`}
            >
              <div className={isActive ? "text-footer-active" : "text-heading"}>
                {typeof item.icon === "function"
                  ? item.icon(isActive)
                  : item.icon}
              </div>
              <p
                className={`fs-12 text-footer ${
                  isActive ? "text-footer-active mb-0" : "text-heading mb-0"
                }`}
              >
                {item.name}
              </p>
            </Link>
          );
        })}
      </div>
    </footer>
  );
};

export default Footer;
